import { render, staticRenderFns } from "./ListCredenciamento.vue?vue&type=template&id=a82889c0"
import script from "./ListCredenciamento.vue?vue&type=script&lang=js"
export * from "./ListCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./ListCredenciamento.vue?vue&type=style&index=0&id=a82889c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports